export const brandPerformanceConstants = {
  ALL_GROUP_RESPONSE_DATA: "ALL_GROUP_RESPONSE_DATA",
  ALL_RESTAURANT_RESPONSE_DATA: "ALL_RESTAURANT_RESPONSE_DATA",
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA: "CUSTOMER_RESPONSES_EXPORT_ALL_DATA",
  GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING:
    "GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING",
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING:
    "STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING",
  GET_AVERAGE_RATING_RESPONSES: "GET_AVERAGE_RATING_RESPONSES",
  GET_RECORD_PAGINATION_RESPONSES: "GET_RECORD_PAGINATION_RESPONSES",
  EXPORT_DETAILED_CUSTOMER_SURVEY_DATA: "EXPORT_DETAILED_CUSTOMER_SURVEY_DATA",
};

export const buttonGroupConstant = {
  GROUP: "group",
  MANAGER: "manager",
  STORE: "store",
};

export const storesExportHeaders = [
  { label: "STORE NAME", key: "name" },
  { label: "TOTAL RESPONSES", key: "recordCount" },
  { label: "AVERAGE TRANSACTION RATING", key: "transactionRating" },
  { label: "PREVIOUS", key: "previousTransactionRating" },
  { label: "TRANSACTION CHANGE", key: "transactionChange" },
  { label: "AVERAGE SENTIMENT RATING", key: "sentimentRating" },
  { label: "PREVIOUS", key: "previousSentimentRating" },
  { label: "SENTIMENT CHANGE", key: "sentimentChange" },
];

export const groupsExportHeaders = [
  { label: "GROUP NAME", key: "name" },
  { label: "TOTAL RESPONSES", key: "recordCount" },
  { label: "AVERAGE TRANSACTION RATING", key: "transactionRating" },
  { label: "PREVIOUS", key: "previousTransactionRating" },
  { label: "TRANSACTION CHANGE", key: "transactionChange" },
  { label: "AVERAGE SENTIMENT RATING", key: "sentimentRating" },
  { label: "PREVIOUS", key: "previousSentimentRating" },
  { label: "SENTIMENT CHANGE", key: "sentimentChange" },
];

export const columnHeadersConstants = {
  SENTIMENT_CHANGE: "SENTIMENT CHANGE",
  TRANSACTION_CHANGE: "TRANSACTION CHANGE",
  AVERAGE_SENTIMENT_RATING: "AVERAGE SENTIMENT RATING",
  AVERAGE_TRANSACTION_RATING: "AVERAGE TRANSACTION RATING",
};

export const brandPerformanceStoresName = "Brand Performance (Stores)";
export const brandPerformanceGroupsName = "Brand Performance (Groups)";

export const BRAND_PERFORMANCE_SORTING = Object.freeze({ id: "name", desc: true });
export const BRAND_PERFORMANCE_DISPLAY = Object.freeze({
  MOBILE_BUTTON_BREAKPOINT: 786,
  FILTER_MENU_HEIGHT: 200,
  FILTER_MENU_PLACEMENT: "auto",
  MISSING_RATING: "-",
});
export const BRAND_PERFORMANCE_FILTER_STYLES = {
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isSelected ? "transparent" : "auto",
    color: state.isDisabled ? "gray" : "black",
  }),
};
